document.addEventListener("click", function(e) {

    var button = e.target.closest(".shop-button");
    if (!button) return;

    e.preventDefault();

    var variantId = button.getAttribute("data-variant-id");
    button.classList.add("loading");

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        id: variantId,
        quantity: 1
        })
    })
    .then(response => response.json())
    .then(data => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    })
    .catch(error => {
        console.error('Cart Error:', error);
    })
    .finally(() => {
        button.classList.remove("loading");
    });
});